<div class="approval-modal-overlay">
  <div class="approval-modal">
    <div class="modal-header">
      <div>
        <h2>Reject {{ data.jobTitle }}</h2>
        <p>Comments are sent to {{ data.companyName }} admin.</p>
      </div>

      <button class="close-btn">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <label class="modal-label"> Comments </label>

      <textarea
        class="modal-textarea"
        placeholder="Reason for rejection..."
        [(ngModel)]="rejection_reason"
      ></textarea>
      <small class="smaller-text text-danger" *ngIf="showValidationError">
        Rejection reason is required and must be at least 5 characters.
      </small>
    </div>

    <div class="modal-footer">
      <button class="cancel-btn" type="button" (click)="closeDialogBox()">
        Cancel
      </button>

      <button class="send-btn" (click)="confirmApproval()">Send</button>
    </div>
  </div>
</div>
